"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingCell = exports.LoadingContainer = exports.Modal = void 0;
const modal_1 = __importDefault(require("@kyruus/modal"));
const styled_1 = __importDefault(require("@emotion/styled"));
const styles_1 = require("../Shimmer/styles");
exports.Modal = (0, styled_1.default)(modal_1.default) `
  display: flex;
  justify-content: center;
  align-items: center;
`;
exports.LoadingContainer = (0, styled_1.default)('div') `
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: space-between;
`;
exports.LoadingCell = (0, styled_1.default)(styles_1.ShimmerBase) ``;
//# sourceMappingURL=styles.js.map